import { ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
import { SharedModalsMap } from './Modals/SharedModals/sharedModals';
import React from 'react';
import { ModalsMap } from './Modals/Modals';
export const ModalsExtension = ModuleExtensions.modalsExtension({
  [ModalsMap.domainTakenInWix]: /*#__PURE__*/React.lazy(async () => ({
    default: (await import('./Modals/DomainTakenInWix/DomainTakenInWix')).DomainTakenInWix
  })),
  [ModalsMap.alreadyAssigned]: /*#__PURE__*/React.lazy(async () => ({
    default: (await import('./Modals/AssignToDifferentSite/AssignToDifferentSite')).AssignToDifferentSite
  })),
  [ModalsMap.languageCodeSubdomain]: /*#__PURE__*/React.lazy(async () => ({
    default: (await import('./Modals/CountryCodeSubdomain/CountryCodeSubdomain')).CountryCodeSubdomain
  })),
  [ModalsMap.upgradeRequireConnect]: /*#__PURE__*/React.lazy(async () => ({
    default: (await import('./Modals/UpgradeConnect/UpgradeConnect')).UpgradeConnect
  })),
  [ModalsMap.upgradePaywall]: /*#__PURE__*/React.lazy(async () => ({
    default: (await import('./Modals/UpgradePaywall')).UpgradePaywall
  })),
  [ModalsMap.upgradePaywallModal]: /*#__PURE__*/React.lazy(async () => ({
    default: (await import('./Modals/UpgradePaywall/UpgradePaywallModal')).UpgradePaywallModal
  })),
  [ModalsMap.transfer]: /*#__PURE__*/React.lazy(async () => ({
    default: (await import('./Modals/TransferIn/TransferIn')).TransferIn
  })),
  [ModalsMap.googleCustomerExists]: /*#__PURE__*/React.lazy(async () => ({
    default: (await import('./Modals/GoogleCustomerExists/GoogleCustomerExistsModal')).GoogleCustomerExistsModal
  })),
  [ModalsMap.googleRestrictedWord]: /*#__PURE__*/React.lazy(async () => ({
    default: (await import('./Modals/GoogleRestrictedWord/GoogleRestrictedWordModal')).GoogleRestrictedWordModal
  }))
}, {
  sdkName: 'domainsActionsModals',
  version: 1
});
export const SharedModalsExtension = ModuleExtensions.modalsExtension({
  [SharedModalsMap.EMPTY_MODAL]: /*#__PURE__*/React.lazy(async () => ({
    default: (await import('./Modals/SharedModals')).EmptyModal
  })),
  [SharedModalsMap.LOADER_MODAL]: /*#__PURE__*/React.lazy(async () => ({
    default: (await import('./Modals/SharedModals')).LoaderModal
  })),
  [SharedModalsMap.INFO_MODAL]: /*#__PURE__*/React.lazy(async () => ({
    default: (await import('../../../components/InfoModal')).InfoModal
  })),
  [SharedModalsMap.AVAILABLE_EXTENSIONS_MODAL]: /*#__PURE__*/React.lazy(async () => ({
    default: (await import('./Modals/SharedModals')).AvailableExtensionsModal
  })),
  [SharedModalsMap.SITE_SELECTOR_MODAL]: /*#__PURE__*/React.lazy(async () => ({
    default: (await import('../../../components/SiteSelectorModal')).SiteSelectorModal
  })),
  [SharedModalsMap.TLDS_SHEET]: /*#__PURE__*/React.lazy(async () => ({
    default: (await import('../../../components/TldsSheet')).TldsSheet
  }))
}, {
  sdkName: 'domainsSharedModals',
  version: 1
});
//# sourceMappingURL=ModalsExtension.js.map